import { ENV } from "../utils";

// Cliente de la API del módulo SBTi (server/router/sbti.js).
// Mismo patrón que el resto de client/src/api: fetch nativo, clase con
// baseApi, throw del `result` si el status no es 200.
export class Sbti {
  baseApi = ENV.BASE_API;

  async getExpediente(accessToken, company) {
    try {
      const url = `${this.baseApi}/sbti/expediente/${company}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateExpediente(accessToken, company, data) {
    try {
      const url = `${this.baseApi}/sbti/expediente/${company}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async patchSection(accessToken, company, section, data) {
    try {
      const url = `${this.baseApi}/sbti/expediente/${company}/${section}`;
      const params = {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async syncGei(accessToken, company, modo = "auto", anio = undefined) {
    try {
      const url = `${this.baseApi}/sbti/${company}/sync-gei`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(anio ? { modo, anio } : { modo }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      // 501 = SBTI-012 todavía no resuelta (ver server/services/sbtiGeiFetcher.js).
      // No es un error de red: el caller lo distingue por result/status, no por catch.
      if (response.status !== 200 && response.status !== 501) throw result;
      return { ok: response.status === 200, status: response.status, ...result };
    } catch (error) {
      throw error;
    }
  }

  async exportExpediente(accessToken, company) {
    try {
      const url = `${this.baseApi}/sbti/${company}/export`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async importExpediente(accessToken, company, data) {
    try {
      const url = `${this.baseApi}/sbti/${company}/import`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
